import {useMemo} from 'react';
import type {CodeListMap} from 'services/codelists/types';
import {useExpressionManifestationsLocalCodelist} from './useExpressionManifestationsLocalCodelist';

export const useExpressionLocalCodelistMap = (
  expressionId: string,
): CodeListMap => {
  const expressionManifestationCodelist =
    useExpressionManifestationsLocalCodelist(expressionId);
  return useMemo(
    (): CodeListMap => ({
      expression_manifestation: expressionManifestationCodelist,
    }),
    [expressionManifestationCodelist],
  );
};
